/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Default_LabelInputs */

const cs_social_export_default_label = /** @type {(inputs: Social_Export_Default_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příspěvek`)
};

const en_social_export_default_label = /** @type {(inputs: Social_Export_Default_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social post`)
};

/**
* | output |
* | --- |
* | "Social post" |
*
* @param {Social_Export_Default_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_default_label = /** @type {((inputs?: Social_Export_Default_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Default_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_default_label(inputs)
	return cs_social_export_default_label(inputs)
});